export function clearThreadsDataFromLocalstorage(): void {
	for (const [key] of Object.entries(localStorage)) {
		if (key.includes('th_id_in')) {
			localStorage.removeItem(key);
		}
	}
}
